/*
 * @Author: l_hc
 * @LastEditors: pfy
 * @Date: 2019-08-08 19:37:50
 * @LastEditTime: 2019-09-23 16:06:37
 * @Version: 1.0
 * @Description: 表单验证
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */

const validateArr = {
  // 用户名验证
  username: {
    reg: /^[\w\u4e00-\u9fa5]{1,20}$/,
    title: '请输入有效的用户名(最多20位字符)'
  },
  // 手机号验证
  phone: {
    reg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
    title: '请输入有效的手机号码'
  },
  // 邮箱验证
  email: {
    reg: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z]{2,4})+$/,
    title: '请输入正确的邮箱格式'
  },
  // 姓名
  name: {
    reg: /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/,
    title: '请输入有效的姓名(2-20位字符)'
  },
  // 中英文姓名
  names: {
    reg: /^[\u4e00-\u9fa5a-zA-Z]{2,25}$/,
    title: '请输入有效的姓名(2-25位字符)'
  },
  // 昵称
  nickname: {
    reg: /^[\w\u4e00-\u9fa5]{0,20}$/,
    title: '请输入有效的昵称(最多20位字符)'
  },
  // 公司名称
  company: {
    reg: /^([a-zA-Z0-9_\u4e00-\u9fa5]){3,30}$/,
    title: '请输入有效的公司(3-30位字符)'
  },
  // 密码验证
  password: {
    reg: /^([a-zA-Z0-9]|[!@#$%^&*.`~'"|]){6,20}$/i,
    // reg: /^[\u4E00-\u9FA5\uF900-\uFA2D\u0020]*$/,
    title: '请输入密码'
  },
  // 验证码
  code: {
    reg: /^[a-zA-Z0-9]{6,15}$/,
    title: '请输入(4-6位数验证码)'
  },
  // 正数（包括小数）验证
  number: {
    reg: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
    title: '请输入正确内容(正数、包括小数)'
  },
  // 正数（包括小数）且小数点最多两位验证
  // positiveNumber: {
  //   reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
  //   title: '请输入正确内容(正数、包括小数)，且小数点最多两位'
  // },
  // 正数（包括小数）且小数点最多两位验证
  positiveNumber: {
    reg: /^(\+|-)?[0-9]{1,7}(\.\d{1,2})?$/,
    title: '请输入最多7位(数字、小数)，且小数点最多两位'
  },
  // 中文大写字母小写字母限制2-20个字符
  character: {
    reg: /^[\u4e00-\u9fa5A-Za-z]{2,20}$/,
    title: '请输入正确内容(不得超过20位字符)'
  },
  // 固话号码
  fixedLine: {
    reg: /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
    // reg: /^([0-9]{3,4}-)?[0-9]{7,8}$/,
    title: '请输入正确固话'
  }
}

// 中文校验 regular：正则，check：校验（非空） checkEmpty :校验（为空）
export var character = (startSize, endSize, method) => {
  // 正则： 中文、英文、数字包括逗号、句号、感叹号、括号以及限定长度
  // var reg = new RegExp('(^[\\u4e00-\\u9fa5A-Za-z0-9])+([^]  ){' + startSize + ',' + endSize + '}$')
  var reg = new RegExp('^[\\u4e00-\\u9fa5A-Za-z0-9]{' + startSize + ',' + endSize + '}$')
  const title = `请输入正确内容(不得超过${endSize}位字符)`
  if (method == 'regular') {
    return reg
  }
  return (rule, value, callback) => {
    if (!value) {
      if (method == 'checkEmpty') {
        callback()
      } else {
        callback(new Error(title))
      }
    } else {
      if (reg.test(value) === false) {
        callback(new Error(title))
      } else {
        callback()
      }
    }
  }
}

export default type => {
  const item = validateArr[type]
  return (rule, value, callback) => {
    // if (!value) {
    //   if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
    //     callback()
    //   }
    // } else if (item.reg.test(value) === false) {
    //   callback(new Error(item.title))
    // } else {
    //   callback()
    // }
    if (value != '') {
      if (item.reg.test(value) === false) {
        callback(new Error(item.title))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
}
export function isNormalString(val, length) {
  const rule = '([a-zA-Z0-9\u4e00-\u9fa5])'
  if (!length) {
    const reg = new RegExp(`^${rule}*$`)
    return reg.test(val)
  } else {
    const reg = new RegExp(`^${rule}{0,${length}}$`)
    return reg.test(val)
  }
}

// 验证特殊字符
export const isNormalStringValidator = (rule, value, callback) => {
  if (!value) {
    callback()
  }
  const state = isNormalString(value)
  if (!state) {
    callback(Error('只能填写字母、数字、汉字'))
  }
  callback()
}

